__turbopack_context__.v({
  "crop_wrapper": "vimeoPlayer-module-scss-module__qpVxvW__crop_wrapper",
  "error": "vimeoPlayer-module-scss-module__qpVxvW__error",
  "error_wrapper": "vimeoPlayer-module-scss-module__qpVxvW__error_wrapper",
  "fillHeight": "vimeoPlayer-module-scss-module__qpVxvW__fillHeight",
  "iframe": "vimeoPlayer-module-scss-module__qpVxvW__iframe",
  "loading": "vimeoPlayer-module-scss-module__qpVxvW__loading",
  "missing_id": "vimeoPlayer-module-scss-module__qpVxvW__missing_id",
  "wrapper": "vimeoPlayer-module-scss-module__qpVxvW__wrapper",
  "wrapperFillHeight": "vimeoPlayer-module-scss-module__qpVxvW__wrapperFillHeight",
});
